import { CommonApiFunctions } from '../../common/constants';
import { message } from 'antd';
import { researchUI } from '../../api';
import { ERROR_MSG } from '../Helper/Constant';

export const searchDomains = async (searchText, exactMatch, byAppId = false) => {
    const result = await researchUI({
        function: CommonApiFunctions.COMMON_FUNCTION,
        reqType: CommonApiFunctions.SEARCH_DOMAINS,
        searchText,
        search_by_id: byAppId,
        exact_match: exactMatch,
    }).catch(() => {
        return false;
    });
    if (result.success === 1) {
        return result.data;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const viewDomainReq = async (user = false) => {
    const result = await researchUI({
        function: CommonApiFunctions.COMMON_FUNCTION,
        reqType: CommonApiFunctions.DOMAIN_CHANGES,
        user,
        action: 'VIEW',
    }).catch(() => {
        return false;
    });
    if (result.success === 1) {
        return result.data;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const domainChangeRequest = async (data) => {
    const result = await researchUI({
        function: CommonApiFunctions.COMMON_FUNCTION,
        reqType: CommonApiFunctions.DOMAIN_CHANGES,
        action: 'REQUEST',
        ...data,
    }).catch(() => {
        return false;
    });
    if (result.success === 1) {
        return result.data;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};
